import {
  Add as AddIcon,
  Delete as DeleteIcon,
  Edit as EditIcon,
} from "@mui/icons-material";
import TableSortLabel from "@mui/material/TableSortLabel";
import {
  Alert,
  Autocomplete,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  ListItemText,
  MenuItem,
  Paper,
  Select,
  Stack,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import CharCounter from "../../components/CharCounter";
import api from "../../services/api";
import { ATIVIDADE_POR_GRUPO, GRUPO_ATIVIDADE_OPTIONS, modalidadeEnum } from "../../utils/constants";

const CHAR_LIMITS = {
  titulo: 100,
  descricaoItem: 500,
  observacoesItem: 2000,
};

const AdicionarChecklist = () => {
  useTheme();
  const navigate = useNavigate();

  const [titulo, setTitulo] = useState("");
  const [ativo, setAtivo] = useState(true);
  const [tipoLicenca, setTipoLicenca] = useState(null);
  const [modalidade, setModalidade] = useState("");
  const [grupoAtividade, setGrupoAtividade] = useState("");
  const [atividadesEmpreendimento, setAtividadesEmpreendimento] = useState([]);

  const [tipoOptions, setTipoOptions] = useState([]);
  const [tipoLoadingOptions, setTipoLoadingOptions] = useState(false);
  const [tipoInputValue, setTipoInputValue] = useState("");

  const [itens, setItens] = useState([]);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const [checklists, setChecklists] = useState([]);
  const [filtroNome, setFiltroNome] = useState("");
  const [filtroNomeDebounced, setFiltroNomeDebounced] = useState("");

  const [filtroTipoLicenca, setFiltroTipoLicenca] = useState(null);
  const [filtroTipoInput, setFiltroTipoInput] = useState("");
  const [filtroTipoOptions, setFiltroTipoOptions] = useState([]);
  const [filtroTipoLoading, setFiltroTipoLoading] = useState(false);
  const [filtroModalidade, setFiltroModalidade] = useState("");
  const [filtroGrupo, setFiltroGrupo] = useState("");
  const [filtroAtividade, setFiltroAtividade] = useState("");

  const [loadingLista, setLoadingLista] = useState(false);
  const [paginaAtual, setPaginaAtual] = useState(1);
  const [itensPorPagina, setItensPorPagina] = useState(10);
  const [totalChecklists, setTotalChecklists] = useState(0);
  const [totalPaginas, setTotalPaginas] = useState(0);

  const [deleteTarget, setDeleteTarget] = useState(null);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const [sortBy, setSortBy] = useState(null);
  const [sortDir, setSortDir] = useState("asc");

  const handleSort = (coluna) => {
    if (sortBy === coluna) {
      setSortDir((prev) => (prev === "asc" ? "desc" : "asc"));
    } else {
      setSortBy(coluna);
      setSortDir("asc");
    }
  };

  const [editingTarget, setEditingTarget] = useState(null);

  const tipoTimerRef = useRef(null);
  const filtroTipoTimerRef = useRef(null);

  const normalizarListaChecklists = (payload, pageNumber, pageSize) => {
    if (Array.isArray(payload)) {
      return {
        lista: payload,
        total: payload.length,
        pageNumber,
        pageSize,
        totalPages: Math.ceil(payload.length / pageSize),
      };
    }

    if (Array.isArray(payload?.data)) {
      const total = Number(payload?.total) || 0;
      const pagina = Number(payload?.pageNumber) || pageNumber;
      const tamanho = Number(payload?.pageSize) || pageSize;
      const totalPages = Number(payload?.totalPages) || 0;

      return {
        lista: payload.data,
        total,
        pageNumber: pagina,
        pageSize: tamanho,
        totalPages,
      };
    }

    return {
      lista: [],
      total: 0,
      pageNumber,
      pageSize,
      totalPages: 0,
    };
  };

  const buscarTipos = async (nome) => {
    try {
      setTipoLoadingOptions(true);
      const resp = await api.get("TipoLicenca/GetByNomeAsync", {
        params: { nome },
      });
      setTipoOptions(resp.data || []);
    } catch (err) {
      setTipoOptions([]);
    } finally {
      setTipoLoadingOptions(false);
    }
  };

  useEffect(() => {
    if (tipoTimerRef.current) clearTimeout(tipoTimerRef.current);
    if ((tipoInputValue || "").trim().length >= 3) {
      tipoTimerRef.current = setTimeout(
        () => buscarTipos(tipoInputValue.trim()),
        500,
      );
    } else {
      setTipoOptions([]);
    }
    return () => {
      if (tipoTimerRef.current) clearTimeout(tipoTimerRef.current);
    };
  }, [tipoInputValue]);

  useEffect(() => {
    const t = setTimeout(() => {
      setFiltroNomeDebounced((filtroNome || "").trim());
    }, 500);
    return () => clearTimeout(t);
  }, [filtroNome]);

  const buscarTiposFiltro = async (nome) => {
    try {
      setFiltroTipoLoading(true);
      const resp = await api.get("TipoLicenca/GetByNomeAsync", {
        params: { nome },
      });
      setFiltroTipoOptions(resp.data || []);
    } catch (err) {
      setFiltroTipoOptions([]);
    } finally {
      setFiltroTipoLoading(false);
    }
  };

  useEffect(() => {
    if (filtroTipoTimerRef.current) clearTimeout(filtroTipoTimerRef.current);
    if ((filtroTipoInput || "").trim().length >= 3) {
      filtroTipoTimerRef.current = setTimeout(
        () => buscarTiposFiltro(filtroTipoInput.trim()),
        500,
      );
    } else {
      setFiltroTipoOptions([]);
    }
    return () => {
      if (filtroTipoTimerRef.current) clearTimeout(filtroTipoTimerRef.current);
    };
  }, [filtroTipoInput]);

  const carregarChecklists = useCallback(async (
    titulo = "",
    pageNumber = 1,
    pageSize = 10,
    filtros = {},
  ) => {
    try {
      setLoadingLista(true);
      const params = { titulo, pageNumber, pageSize };
      if (filtros.tipoLicencaId) params.tipoLicencaId = filtros.tipoLicencaId;
      if (filtros.modalidade !== "" && filtros.modalidade != null)
        params.modalidade = filtros.modalidade;
      if (filtros.grupoAtividade !== "" && filtros.grupoAtividade != null)
        params.grupoAtividade = filtros.grupoAtividade;
      if (filtros.atividadeEmpreendimento !== "" && filtros.atividadeEmpreendimento != null)
        params.atividadeEmpreendimento = filtros.atividadeEmpreendimento;

      const response = await api.get("Checklist/GetByTitulo", { params });

      const normalizado = normalizarListaChecklists(
        response.data,
        pageNumber,
        pageSize,
      );

      setChecklists(normalizado.lista);
      setTotalChecklists(normalizado.total);
      setTotalPaginas(normalizado.totalPages);
    } catch (err) {
      setChecklists([]);
      setTotalChecklists(0);
      setTotalPaginas(0);
    } finally {
      setLoadingLista(false);
    }
  }, []);

  const checklistsFiltrados = (() => {
    const lista = Array.isArray(checklists) ? [...checklists] : [];
    if (!sortBy) return lista;
    return lista.sort((a, b) => {
      const aVal = (a[sortBy] || "").toString().toLowerCase();
      const bVal = (b[sortBy] || "").toString().toLowerCase();
      if (aVal < bVal) return sortDir === "asc" ? -1 : 1;
      if (aVal > bVal) return sortDir === "asc" ? 1 : -1;
      return 0;
    });
  })();

  useEffect(() => {
    setPaginaAtual(1);
  }, [filtroNomeDebounced, filtroTipoLicenca, filtroModalidade, filtroGrupo, filtroAtividade]);

  useEffect(() => {
    carregarChecklists(filtroNomeDebounced, paginaAtual, itensPorPagina, {
      tipoLicencaId: filtroTipoLicenca?.id || filtroTipoLicenca?.Id,
      modalidade: filtroModalidade,
      grupoAtividade: filtroGrupo,
      atividadeEmpreendimento: filtroAtividade,
    });
  }, [
    carregarChecklists,
    filtroNomeDebounced,
    paginaAtual,
    itensPorPagina,
    filtroTipoLicenca,
    filtroModalidade,
    filtroGrupo,
    filtroAtividade,
  ]);

  const limparFiltros = () => {
    setFiltroNome("");
    setFiltroTipoLicenca(null);
    setFiltroTipoInput("");
    setFiltroModalidade("");
    setFiltroGrupo("");
    setFiltroAtividade("");
  };

  const handleAdicionarItem = () => {
    const novoItem = {
      id: Date.now(),
      descricao: "",
      obrigatorio: false,
      observacoes: "",
    };
    setItens([...itens, novoItem]);
  };

  const handleRemoverItem = (id) => {
    setItens(itens.filter((item) => item.id !== id));
  };

  const handleAtualizarItem = (id, campo, valor) => {
    setItens(
      itens.map((item) =>
        item.id === id ? { ...item, [campo]: valor } : item,
      ),
    );
  };

  const validarFormulario = () => {
    if (!titulo?.trim()) {
      setError("O campo Título é obrigatório.");
      return false;
    }

    if (!tipoLicenca || typeof tipoLicenca === "string") {
      setError("Escolha um Tipo de Licença válido nas opções.");
      return false;
    }

    if (modalidade === null || modalidade === undefined || modalidade === "") {
      setError("Escolha uma Modalidade.");
      return false;
    }

    if (grupoAtividade === null || grupoAtividade === undefined || grupoAtividade === "") {
      setError("Escolha um Grupo de Atividade.");
      return false;
    }

    if (!atividadesEmpreendimento || atividadesEmpreendimento.length === 0) {
      setError("Escolha ao menos uma Atividade do Empreendimento.");
      return false;
    }

    if (itens.length === 0) {
      setError("Adicione pelo menos um item ao checklist.");
      return false;
    }

    if (itens.some((item) => !item.descricao?.trim())) {
      setError("Todos os itens devem ter uma descrição.");
      return false;
    }

    return true;
  };

  const abrirDialogDelete = (checklist) => {
    setDeleteTarget(checklist);
    setDeleteDialogOpen(true);
  };

  const fecharDialogDelete = () => {
    setDeleteTarget(null);
    setDeleteDialogOpen(false);
  };

  const confirmarDelete = async () => {
    if (!deleteTarget) return;
    try {
      setDeleting(true);
      await api.delete(`/Checklist/${deleteTarget.id}`);
      setChecklists((prev) =>
        Array.isArray(prev) ? prev.filter((c) => c.id !== deleteTarget.id) : [],
      );
      fecharDialogDelete();
    } catch (err) {
      setError(
        err?.response?.data?.message ||
          err?.response?.data?.detail ||
          "Erro ao deletar.",
      );
    } finally {
      setDeleting(false);
    }
  };

  const buscarInfoTipoLicenca = async (id, checklist) => {
    if (id) {
      try {
        const response = await api.get(`TipoLicenca/${id}`);
        setTipoLicenca(response.data);
      } catch (err) {
        setTipoLicenca(checklist.tipoLicencaObject || { id: id });
      }
    } else {
      setTipoLicenca(null);
    }
  };

  const iniciarEdicao = async (checklist) => {
    setEditingTarget(checklist);
    setTitulo(checklist.titulo || "");
    buscarInfoTipoLicenca(checklist.tipoLicencaId, checklist);
    setModalidade(checklist.modalidade ?? "");
    setGrupoAtividade(checklist.grupoAtividade ?? "");
    setAtividadesEmpreendimento(checklist.atividadesEmpreendimento ?? []);
    setAtivo(checklist.isActive ?? checklist.ativo ?? true);

    const itensReconstruidos = (checklist.itensChecklist || []).map((item) => ({
      id: item.id,
      descricao: item.descricao || "",
      obrigatorio: item.obrigatorio ?? false,
      observacoes: item.observacoes || "",
    }));

    setItens(itensReconstruidos);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const cancelarEdicao = () => {
    setEditingTarget(null);
    setTitulo("");
    setTipoLicenca(null);
    setModalidade("");
    setGrupoAtividade("");
    setAtividadesEmpreendimento([]);
    setAtivo(true);
    setItens([]);
    setError(null);
    setSuccess(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);

    if (!validarFormulario()) {
      return;
    }

    try {
      setLoading(true);

      const payload = {
        ...(editingTarget && { Id: editingTarget.id }),
        Titulo: titulo.trim(),
        TipoLicencaId: tipoLicenca?.id || tipoLicenca?.Id || null,
        Modalidade: parseInt(modalidade),
        GrupoAtividade: parseInt(grupoAtividade),
        AtividadesEmpreendimento: atividadesEmpreendimento.map((v) => parseInt(v)),
        IsActive: !!ativo,
        ItensChecklist: itens.map((item) => ({
          Id: item.id > Date.now() - 1000000 ? null : item.id,
          Descricao: item.descricao.trim(),
          Obrigatorio: !!item.obrigatorio,
          Observacoes: item.observacoes.trim() || null,
        })),
      };

      if (editingTarget) {
        await api.put(`Checklist/`, payload);
        setChecklists((prev) =>
          (Array.isArray(prev) ? prev : []).map((c) =>
            c.id === editingTarget.id
              ? {
                  ...c,
                  titulo: payload.titulo,
                  tipoLicencaId: payload.tipoLicencaId,
                  modalidade: payload.modalidade,
                  isActive: payload.isActive,
                }
              : c,
          ),
        );
        setSuccess("Checklist atualizado com sucesso!");
        setEditingTarget(null);
      } else {
        await api.post("Checklist", payload);
        setSuccess("Checklist criado com sucesso!");
      }

      setTitulo("");
      setTipoLicenca(null);
      setModalidade("");
      setGrupoAtividade("");
      setAtividadesEmpreendimento([]);
      setItens([]);

      carregarChecklists(filtroNomeDebounced, paginaAtual, itensPorPagina, {
        tipoLicencaId: filtroTipoLicenca?.id || filtroTipoLicenca?.Id,
        modalidade: filtroModalidade,
        grupoAtividade: filtroGrupo,
        atividadeEmpreendimento: filtroAtividade,
      });
    } catch (err) {
      setError(
        err?.response?.data?.detail ||
          err?.response?.data?.message ||
          "Erro ao salvar.",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container
      maxWidth="lg"
      sx={{
        mt: { xs: 2, md: 4 },
        mb: { xs: 2, md: 4 },
        px: { xs: 2, sm: 3, md: 4 },
      }}
    >
      <Paper sx={{ p: { xs: 2, md: 3 }, borderRadius: 2 }} elevation={3}>
        <Box sx={{ mb: 3, display: "flex", alignItems: "center" }}>
          <Typography
            variant="h5"
            component="h1"
            fontWeight="bold"
            color="primary.main"
            sx={{ fontSize: { xs: "1.2rem", sm: "1.5rem" } }}
          >
            Adicionar Checklist
          </Typography>
        </Box>

        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        {success && (
          <Alert severity="success" sx={{ mb: 2 }}>
            {success}
          </Alert>
        )}

        <Box component="form" onSubmit={handleSubmit} noValidate>
          <Typography variant="h6" sx={{ mb: 2, mt: 3, fontWeight: "bold" }}>
            Informações Principais
          </Typography>

          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={12}>
              <TextField
                label="Título"
                placeholder="Título do checklist"
                value={titulo}
                onChange={(e) => setTitulo(e.target.value)}
                inputProps={{ maxLength: CHAR_LIMITS.titulo }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <CharCounter
                        value={titulo}
                        maxLength={CHAR_LIMITS.titulo}
                      />
                    </InputAdornment>
                  ),
                }}
                fullWidth
                required
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <Autocomplete
                options={tipoOptions}
                getOptionLabel={(option) =>
                  typeof option === "string"
                    ? option
                    : option?.nome ||
                      option?.Nome ||
                      option?.codigo ||
                      option?.Codigo ||
                      ""
                }
                value={tipoLicenca}
                isOptionEqualToValue={(option, value) => {
                  if (!option || !value) return false;
                  return (option.id || option.Id) === (value.id || value.Id);
                }}
                onChange={(_, newValue) => {
                  setTipoLicenca(newValue);
                }}
                inputValue={tipoInputValue}
                onInputChange={(_, newInput) => setTipoInputValue(newInput)}
                noOptionsText={
                  tipoInputValue && tipoInputValue.trim().length >= 3
                    ? "Nenhum tipo encontrado"
                    : "Digite 3 ou mais letras"
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Tipo de Licença"
                    placeholder="Ex: Licença Prévia"
                    required
                    fullWidth
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {tipoLoadingOptions ? (
                            <CircularProgress color="inherit" size={18} />
                          ) : null}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl fullWidth required>
                <InputLabel id="modalidade-label">Modalidade</InputLabel>
                <Select
                  labelId="modalidade-label"
                  id="modalidade-select"
                  value={modalidade}
                  onChange={(e) => setModalidade(e.target.value)}
                  label="Modalidade"
                >
                  <MenuItem value="">
                    <em>Selecione uma modalidade</em>
                  </MenuItem>
                  {modalidadeEnum.map((mod) => (
                    <MenuItem key={mod.value} value={mod.value}>
                      {mod.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl fullWidth required>
                <InputLabel id="grupo-atividade-label">Grupo de Atividade</InputLabel>
                <Select
                  labelId="grupo-atividade-label"
                  id="grupo-atividade-select"
                  value={grupoAtividade}
                  onChange={(e) => {
                    setGrupoAtividade(e.target.value);
                    setAtividadesEmpreendimento([]);
                  }}
                  label="Grupo de Atividade"
                >
                  <MenuItem value="">
                    <em>Selecione um grupo</em>
                  </MenuItem>
                  {GRUPO_ATIVIDADE_OPTIONS.map((g) => (
                    <MenuItem key={g.value} value={g.value}>
                      {g.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl fullWidth required>
                <InputLabel id="atividade-empreendimento-label">Atividade do Empreendimento</InputLabel>
                <Select
                  labelId="atividade-empreendimento-label"
                  id="atividade-empreendimento-select"
                  multiple
                  value={atividadesEmpreendimento}
                  onChange={(e) => setAtividadesEmpreendimento(e.target.value)}
                  label="Atividade do Empreendimento"
                  disabled={grupoAtividade === null || grupoAtividade === undefined || grupoAtividade === ""}
                  renderValue={(selected) =>
                    selected
                      .map((val) => {
                        const opt = (ATIVIDADE_POR_GRUPO[grupoAtividade] ?? []).find(
                          (a) => a.value === val,
                        );
                        return opt ? opt.label : val;
                      })
                      .join("; ")
                  }
                >
                  {(ATIVIDADE_POR_GRUPO[grupoAtividade] ?? []).map((a) => (
                    <MenuItem key={a.value} value={a.value}>
                      <Checkbox checked={atividadesEmpreendimento.includes(a.value)} />
                      <ListItemText primary={a.label} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Switch
                    checked={ativo}
                    onChange={(e) => setAtivo(e.target.checked)}
                    color="primary"
                  />
                }
                label={`Ativo: ${ativo ? "Sim" : "Não"}`}
              />
            </Grid>
          </Grid>

          <Box sx={{ mb: 3 }}>
            <Box
              sx={{
                display: "flex",
                alignItems: { xs: "stretch", sm: "center" },
                justifyContent: "space-between",
                flexDirection: { xs: "column", sm: "row" },
                gap: 2,
                mb: 2,
              }}
            >
              <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                Itens do Checklist
              </Typography>
              <Button
                variant="contained"
                startIcon={<AddIcon />}
                onClick={handleAdicionarItem}
                size="small"
                sx={{ width: { xs: "100%", sm: "auto" } }}
              >
                Adicionar Item
              </Button>
            </Box>

            {itens.length === 0 ? (
              <Paper
                sx={{ p: 2, textAlign: "center", bgcolor: "action.hover" }}
              >
                <Typography color="text.secondary">
                  Nenhum item adicionado. Clique em "Adicionar Item" para
                  começar.
                </Typography>
              </Paper>
            ) : (
              <TableContainer component={Paper} sx={{ overflowX: "auto" }}>
                <Table>
                  <TableHead sx={{ bgcolor: "action.hover" }}>
                    <TableRow>
                      <TableCell sx={{ fontWeight: "bold", minWidth: 300 }}>
                        Descrição
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ fontWeight: "bold", minWidth: 100 }}
                      >
                        Obrigatório
                      </TableCell>
                      <TableCell sx={{ fontWeight: "bold", minWidth: 250 }}>
                        Observações
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ fontWeight: "bold", minWidth: 60 }}
                      >
                        Ação
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {itens.map((item, index) => (
                      <TableRow key={item.id}>
                        <TableCell>
                          <TextField
                            placeholder="Descrição do item"
                            value={item.descricao}
                            onChange={(e) =>
                              handleAtualizarItem(
                                item.id,
                                "descricao",
                                e.target.value,
                              )
                            }
                            fullWidth
                            size="small"
                            inputProps={{ maxLength: CHAR_LIMITS.descricaoItem }}
                            required
                          />
                        </TableCell>
                        <TableCell align="center">
                          <FormControlLabel
                            control={
                              <Switch
                                checked={item.obrigatorio}
                                onChange={(e) =>
                                  handleAtualizarItem(
                                    item.id,
                                    "obrigatorio",
                                    e.target.checked,
                                  )
                                }
                                size="small"
                              />
                            }
                            label=""
                          />
                        </TableCell>
                        <TableCell>
                          <TextField
                            placeholder="Observações (opcional)"
                            value={item.observacoes}
                            onChange={(e) =>
                              handleAtualizarItem(
                                item.id,
                                "observacoes",
                                e.target.value,
                              )
                            }
                            fullWidth
                            size="small"
                            multiline
                            minRows={1}
                            maxRows={3}
                            inputProps={{
                              maxLength: CHAR_LIMITS.observacoesItem,
                            }}
                            helperText={
                              CHAR_LIMITS.observacoesItem -
                                (item.observacoes?.length || 0) <=
                              10
                                ? `${item.observacoes?.length || 0}/${CHAR_LIMITS.observacoesItem}`
                                : ""
                            }
                          />
                        </TableCell>
                        <TableCell align="center">
                          <IconButton
                            color="error"
                            size="small"
                            onClick={() => handleRemoverItem(item.id)}
                            aria-label="Remover item"
                          >
                            <DeleteIcon />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </Box>

          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={2}
            sx={{ mt: 3 }}
          >
            <Button
              type="submit"
              variant="contained"
              disabled={loading}
              sx={{ textTransform: "none", width: { xs: "100%", sm: "auto" } }}
            >
              {loading ? <CircularProgress size={20} sx={{ mr: 1 }} /> : null}
              {editingTarget ? "Atualizar Checklist" : "Salvar Checklist"}
            </Button>
            <Button
              variant="outlined"
              sx={{ textTransform: "none", width: { xs: "100%", sm: "auto" } }}
              onClick={editingTarget ? cancelarEdicao : () => navigate(-1)}
            >
              {editingTarget ? "Cancelar Edição" : "Cancelar"}
            </Button>
          </Stack>
        </Box>
      </Paper>

      <Paper
        sx={{ p: { xs: 2, md: 3 }, borderRadius: 2, mt: { xs: 3, md: 4 } }}
        elevation={3}
      >
        <Box
          sx={{
            mb: 3,
            display: "flex",
            alignItems: { xs: "flex-start", sm: "center" },
            justifyContent: "space-between",
            flexDirection: { xs: "column", sm: "row" },
            gap: 1,
          }}
        >
          <Typography variant="h6" fontWeight="bold">
            Checklists Existentes
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Total: {totalChecklists} | Página {paginaAtual}
            {totalPaginas > 0 ? ` de ${totalPaginas}` : ""}
          </Typography>
        </Box>

        <Box sx={{ mb: 3 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                label="Filtrar por Título"
                placeholder="Digite o título para filtrar..."
                value={filtroNome}
                onChange={(e) => setFiltroNome(e.target.value)}
                fullWidth
                size="small"
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <Autocomplete
                size="small"
                options={filtroTipoOptions}
                getOptionLabel={(option) =>
                  typeof option === "string"
                    ? option
                    : option?.nome ||
                      option?.Nome ||
                      option?.codigo ||
                      option?.Codigo ||
                      ""
                }
                value={filtroTipoLicenca}
                isOptionEqualToValue={(option, value) => {
                  if (!option || !value) return false;
                  return (option.id || option.Id) === (value.id || value.Id);
                }}
                onChange={(_, newValue) => setFiltroTipoLicenca(newValue)}
                inputValue={filtroTipoInput}
                onInputChange={(_, newInput) => setFiltroTipoInput(newInput)}
                noOptionsText={
                  filtroTipoInput && filtroTipoInput.trim().length >= 3
                    ? "Nenhum tipo encontrado"
                    : "Digite 3 ou mais letras"
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Tipo de Licença"
                    placeholder="Todos"
                    fullWidth
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {filtroTipoLoading ? (
                            <CircularProgress color="inherit" size={18} />
                          ) : null}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <FormControl fullWidth size="small">
                <InputLabel id="filtro-modalidade-label">Modalidade</InputLabel>
                <Select
                  labelId="filtro-modalidade-label"
                  value={filtroModalidade}
                  onChange={(e) => setFiltroModalidade(e.target.value)}
                  label="Modalidade"
                >
                  <MenuItem value="">
                    <em>Todas</em>
                  </MenuItem>
                  {modalidadeEnum.map((mod) => (
                    <MenuItem key={mod.value} value={mod.value}>
                      {mod.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <FormControl fullWidth size="small">
                <InputLabel id="filtro-grupo-label">Grupo de Atividade</InputLabel>
                <Select
                  labelId="filtro-grupo-label"
                  value={filtroGrupo}
                  onChange={(e) => {
                    setFiltroGrupo(e.target.value);
                    setFiltroAtividade("");
                  }}
                  label="Grupo de Atividade"
                >
                  <MenuItem value="">
                    <em>Todos</em>
                  </MenuItem>
                  {GRUPO_ATIVIDADE_OPTIONS.map((g) => (
                    <MenuItem key={g.value} value={g.value}>
                      {g.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <FormControl
                fullWidth
                size="small"
                disabled={filtroGrupo === "" || filtroGrupo === null || filtroGrupo === undefined}
              >
                <InputLabel id="filtro-atividade-label">Atividade do Empreendimento</InputLabel>
                <Select
                  labelId="filtro-atividade-label"
                  value={filtroAtividade}
                  onChange={(e) => setFiltroAtividade(e.target.value)}
                  label="Atividade do Empreendimento"
                >
                  <MenuItem value="">
                    <em>Todas</em>
                  </MenuItem>
                  {(ATIVIDADE_POR_GRUPO[filtroGrupo] ?? []).map((a) => (
                    <MenuItem key={a.value} value={a.value}>
                      {a.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={4} sx={{ display: "flex", alignItems: "center" }}>
              <Button variant="outlined" onClick={limparFiltros} fullWidth>
                Limpar filtros
              </Button>
            </Grid>
          </Grid>
        </Box>

        {loadingLista ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 3 }}>
            <CircularProgress />
          </Box>
        ) : checklistsFiltrados.length === 0 ? (
          <Typography color="text.secondary" align="center" sx={{ py: 2 }}>
            Nenhum checklist encontrado.
          </Typography>
        ) : (
          <>
            <TableContainer
              component={Paper}
              variant="outlined"
              sx={{ overflowX: "auto" }}
            >
              <Table size="small">
                <TableHead sx={{ bgcolor: "action.hover" }}>
                  <TableRow>
                    <TableCell sx={{ fontWeight: "bold" }}>
                      <TableSortLabel
                        active={sortBy === "titulo"}
                        direction={sortBy === "titulo" ? sortDir : "asc"}
                        onClick={() => handleSort("titulo")}
                      >
                        Título
                      </TableSortLabel>
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>
                      <TableSortLabel
                        active={sortBy === "tipoLicencaNome"}
                        direction={sortBy === "tipoLicencaNome" ? sortDir : "asc"}
                        onClick={() => handleSort("tipoLicencaNome")}
                      >
                        Tipo de Licença
                      </TableSortLabel>
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold" }} align="center">
                      Itens
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold" }} align="center">
                      Ativo
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold" }} align="center">
                      Ações
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {checklistsFiltrados.map((checklist) => (
                    <TableRow key={checklist.id} hover>
                      <TableCell>{checklist.titulo}</TableCell>
                      <TableCell>{checklist.tipoLicencaNome}</TableCell>
                      <TableCell align="center">
                        {checklist.itensChecklist?.length || 0}
                      </TableCell>
                      <TableCell align="center">
                        {(checklist.isActive ?? checklist.ativo) ? "Sim" : "Não"}
                      </TableCell>
                      <TableCell align="center">
                        <Box
                          sx={{
                            display: "flex",
                            gap: 1,
                            justifyContent: "center",
                          }}
                        >
                          <IconButton
                            size="small"
                            color="primary"
                            onClick={() => iniciarEdicao(checklist)}
                            aria-label={`Editar ${checklist.titulo}`}
                          >
                            <EditIcon />
                          </IconButton>
                          <IconButton
                            size="small"
                            color="error"
                            onClick={() => abrirDialogDelete(checklist)}
                            aria-label={`Excluir ${checklist.titulo}`}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              component="div"
              count={totalChecklists}
              page={Math.max(0, paginaAtual - 1)}
              onPageChange={(_, newPage) => setPaginaAtual(newPage + 1)}
              rowsPerPage={itensPorPagina}
              onRowsPerPageChange={(event) => {
                setItensPorPagina(parseInt(event.target.value, 10));
                setPaginaAtual(1);
              }}
              rowsPerPageOptions={[5, 10, 20, 50]}
              labelRowsPerPage="Itens por página"
            />
          </>
        )}
      </Paper>
      <Dialog open={deleteDialogOpen} onClose={fecharDialogDelete}>
        <DialogTitle>Confirmação</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Deseja realmente deletar esse checklist?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={fecharDialogDelete} disabled={deleting}>
            Não
          </Button>
          <Button
            onClick={confirmarDelete}
            color="error"
            variant="contained"
            disabled={deleting}
          >
            {deleting ? <CircularProgress size={18} /> : "Sim, deletar"}
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default AdicionarChecklist;
